"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var CellLayout = function (props) {
    var children = props.children, className = props.className, spacing = props.spacing;
    return (react_1["default"].createElement(Grid_1["default"], { container: true, spacing: spacing || 3, className: className }, children));
};
exports["default"] = CellLayout;
